define([
    '../Util/defined',
    '../System/Vec3Obj',
    '../Enum/EnumAlignmentMode',
    '../Enum/EnumRotateMode',
    '../Enum/EnumZoomMode',
], function (
    defined,
    Vec3Obj,
    EnumAlignmentMode,
    EnumRotateMode,
    EnumZoomMode,
) {
    'use strict'

    /**
     * 图标符号。
     * <br /><br />
     * <div align='center'>
     * <img src='images/IconSymbol.png' width='900' height='650' /><br />
     * 图标符号效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/IconSymbol.html|CooWasm IconSymbol demo}
     * @alias IconSymbol
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {EnumAlignmentMode} [props.alignMode=EnumAlignmentMode.CENTER_CENTER] 图标相对原点对齐方式。
     * @param {EnumRotateMode} [props.rotateMode=EnumRotateMode.TO_SCREEN] 图标朝向方式。
     * @param {EnumZoomMode} [props.zoomMode=EnumZoomMode.CAMERA] 图标缩放方式。
     * @param {Number} [props.zoomLimit=2000.0] 图标缩放上限值，单位：米。
     * @param {Number} [props.liftUp=0.0] 图标抬高高度，单位：米。
     * @param {Number} [props.minDistance=1.0] 最小可视距离。
     * @param {Number} [props.maxDistance=20000.0] 最大可视距离。
     * @param {Number} [props.scale=1] 图标比例值。
     * @param {String} props.url 图标路径。
     * @example
     * var icon = new CooWasm.IconSymbol({});
     */
    class IconSymbol {
        /**
         * @description 图标相对原点对齐方式。
         * @type {EnumAlignmentMode}
         */
        alignMode
        /**
         * @description 图标朝向方式。
         * @type {EnumRotateMode}
         */
        rotateMode
        /**
         * @description 图标缩放方式。
         * @type {EnumZoomMode}
         */
        zoomMode
        /**
         * @description 图标缩放上限值，单位：米。
         * @type {Number}
         */
        zoomLimit
        /**
         * @description 图标抬高高度，单位：米。
         * @type {Number}
         */
        liftUp
        /**
         * @description 最小可视距离。
         * @type {Number}
         */
        minDistance
        /**
         * @description 最大可视距离。
         * @type {Number}
         */
        maxDistance
        /**
         * @description 图标比例值。
         * @type {Number}
         * @readonly
         */
        scale
        /**
         * @description 图标路径。
         * @type {String}
         */
        url
        /**
         * @description 上方向轴。
         * @type {Vec3Obj}
         * @readonly
         */
        upAxis
        /**
         * @description 属性信息。
         * @private
         * @readonly
         */
        properties = ""
        /**
         * @description IconSymbol在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "IconSymbol"

        constructor(props) {
            if (!defined(props)) {
                props = {}
            }
            this.properties += this.toStr("url", props.url, "Url")
            this.properties += this.toStr("alignMode", props.alignMode, "AlignmentMode")
            this.properties += this.toStr("rotateMode", props.rotateMode, "RotateMode")
            this.properties += this.toStr("zoomMode", props.zoomMode, "ZoomMode")
            this.properties += this.toStr("zoomLimit", props.zoomLimit, "ZoomMaxDistance")
            this.properties += this.toStr("liftUp", props.liftUp, "LiftUp")
            this.properties += this.toStr("minDistance", props.minDistance, "MinVisibleDistance")
            this.properties += this.toStr("maxDistance", props.maxDistance, "MaxVisibleDistance")
            this.properties += this.toStr("scale", props.scale, "Scale")
        }

        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        
        update(symbol) {
            let componentProps = ""
            if (!defined(symbol)) {
                return componentProps
            }
            if (defined(symbol.alignMode)) {
                this.alignMode = symbol.alignMode
                componentProps += "AlignmentMode:" + this.alignMode + "|"
            }
            if (defined(symbol.rotateMode)) {
                this.rotateMode = symbol.rotateMode
                componentProps += "RotateMode:" + this.rotateMode + "|"
            }
            if (defined(symbol.zoomMode)) {
                this.zoomMode = symbol.zoomMode
                componentProps += "ZoomMode:" + this.zoomMode + "|"
            }
            if (defined(symbol.zoomLimit)) {
                this.zoomLimit = symbol.zoomLimit
                componentProps += "ZoomMaxDistance:" + this.zoomLimit + "|"
            }
            if (defined(symbol.minDistance)) {
                this.minDistance = symbol.minDistance
                componentProps += "MinVisibleDistance:" + this.minDistance + "|"
            }
            if (defined(symbol.maxDistance)) {
                this.maxDistance = symbol.maxDistance
                componentProps += "MaxVisibleDistance:" + this.maxDistance + "|"
            }
            if (defined(symbol.liftUp)) {
                this.liftUp = symbol.liftUp
                componentProps += "LiftUp:" + this.liftUp + "|"
            }
            if (defined(symbol.scale)) {
                this.scale = symbol.scale
                componentProps += "Scale:" + this.scale + "|"
            }
            if (defined(symbol.url)) {
                this.url = symbol.url
                componentProps += "Url:" + this.url + "|"
            }
            return componentProps
        }
    }
    return IconSymbol
})